import React, { useEffect, useState } from "react";
import { Table, Button, Popover, OverlayTrigger } from "react-bootstrap";
import { fetchAllUser } from "../../service/UserService";
import { Edit, Eye, Trash } from "lucide-react";

const SubscriptionList = ({ Subscription, onEdit, onDelete, onView }) => {
  const [users, setUsers] = useState([]);

    const loadUsers = async () => {
      try {
        const res =await fetchAllUser();
        console.log(res);
        
        setUsers(res);
      } catch (error) {
        console.error("Error in Fetch");
      }
    }
  
    useEffect(() => {
      loadUsers();
    }, [])
    const viewPopover = (
      <Popover id="popover-view">
        <Popover.Body>View Subscriper details</Popover.Body>
      </Popover>
    );
    const editPopover = (
      <Popover id="popover-view">
        <Popover.Body>Edit Subscriber details</Popover.Body>
      </Popover>
    );
    const deletePopover = (
      <Popover id="popover-view">
        <Popover.Body>Delete Subscriber </Popover.Body>
      </Popover>
    );
  return (
    <Table className="custom-employee-table" bordered hover responsive>
      <thead>
        <tr>
          <th>SI.NO</th>
          <th>UserName</th>
          <th>plan</th>
          <th>amount</th>
          <th>paymentMode</th>
          <th>paymentParticulars</th>
          <th>expiryDate</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {Subscription.length > 0 ? (
          Subscription.map((sub, idx) => {
            const matchedUser = users.find((user) => user.userId === sub.userId);
            return (
              <tr key={sub.id}>
                <td>{idx + 1}</td>
                <td>{matchedUser?.username || "NA"}</td>
                <td>{sub.plan}</td>
                <td>{sub.amount}</td>
                <td>{sub.paymentMode}</td>
                <td>{sub.paymentParticulars}</td>
                <td>{sub.expiryDate}</td>

                <td>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={viewPopover}
                  >
                    <Button
                      size="sm"
                      className="me-1"
                      style={{
                        backgroundColor: "#10296C",
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onView(sub)}
                    >
                      <Eye />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={editPopover}
                  >
                    <Button
                      size="sm"
                      variant="warning"
                      className="me-1"
                      style={{
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onEdit(sub)}
                    >
                      <Edit />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={deletePopover}
                  >
                    <Button
                      size="sm"
                      variant="danger"
                      style={{
                        
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onDelete(sub.id)}
                    >
                      <Trash />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            ); 
          })
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              Not found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default SubscriptionList;
